





































































































































import {API} from '@/services/api/api';
import validator from '@/utils/validator';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['currentTabActionPlan'])},
})
export default class Surveyor extends Vue {
  @Prop({default: false}) canFetchDataFromAPI!: boolean;
  currentTabActionPlan: any;

  showSuccessToast: any;
  showErrorToast: any;
  isScreenLoading = true;
  btnLoader = false;
  surveyorClass: number = null;
  isReadOnly = false;

  classValidationMsg = '';
  surveyorName = '';
  surveyorNameValiMsg = '';
  isVerified = true;
  isVerifiedValiMsg = '';
  comment = '';
  commonValidationMsg = 'This field is required';
  inspectionId = this.$route.params.id;

  classList = [];

  mounted() {
    this.getClassList();
    if (this.currentTabActionPlan.child === this.currentTabActionPlan.navigateTo) this.isReadOnly = false;
    else this.isReadOnly = true;
    this.getActionPlanData();
  }

  async getActionPlanData() {
    try {
      this.isScreenLoading = true;
      let response = await API.fetchActionPlanDataByInspectionId(this.inspectionId);

      if (response.data) {
        const data = response.data;
        const surveyorData = data.surveyor;
        this.surveyorClass = surveyorData.classID;
        this.surveyorName = surveyorData.surveyorName;
        this.isVerified = surveyorData.isVerified;
        this.comment = surveyorData.comment;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async getClassList() {
    try {
      const response = await API.fetchClassList();

      if (response.data) {
        const data = response.data;
        this.classList = data;
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  validateClass() {
    if (validator.isNullOrEmpty(this.surveyorClass)) {
      this.classValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.classValidationMsg = '';
      return true;
    }
  }

  validateSurveyorName() {
    if (validator.isNullOrEmpty(this.surveyorName)) {
      this.surveyorNameValiMsg = this.commonValidationMsg;
      return false;
    } else {
      this.surveyorNameValiMsg = '';
      return true;
    }
  }

  validateAll() {
    return this.validateClass() && this.validateSurveyorName() && this.isVerified;
  }

  async onSaveClick() {
    if (this.validateAll()) {
      try {
        this.btnLoader = true;

        const params = {
          inspectionId: this.inspectionId,
          surveyor: {
            classID: this.surveyorClass,
            surveyorName: this.surveyorName,
            isVerified: this.isVerified,
            comment: this.comment,
          },
        };

        const response = await API.saveActionPlanData(params);
        if (response.data) {
          this.$router.push('/inspection-list');
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);
        this.showErrorToast({msg: error});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  onCancelClick() {
    this.$router.go(-1);
  }
}
